import React, { useState, useMemo } from 'react'
import { SketchPicker } from 'react-color'
import check from './check.png'
import './ColorPicker.css'

const ColorPicker = (props) => {
    
    let [color,setColor] = useState(props.noteColor)

    function completeColorChange(newColor){
        console.log(newColor.hex)
        setColor(newColor.hex)
        props.handleColorChange(newColor.hex)
        console.log("Color completeColorChange Note Id: " + props.note.id)


    }
    function handleAccept(){
        props.toggleColorPicker()
    }

    const memoColorPicker = useMemo(() => {
        return (
            <div className='color-picker-holder'>
                <div className='color-picker-button' 
                    // style={{backgroundColor:color}} 
                    onClick={handleAccept}>

                    <div className='color-accept'>
                        <img 
                            src={check} 
                            className='check-mark' 
                            alt=''>
                        </img>
                    </div>
                    
                </div>
                <SketchPicker 
                    className='color-picker'
                    // color={color} 
                    // onClick={e => e.stopPropagation()}
                    // onMouseDown={e => e.stopPropagation()}
                    // onMouseMove={e => e.stopPropagation()}
                    onChangeComplete={completeColorChange}
                    
                ></SketchPicker>
            </div>
        )
    }, [props.note.id])



    return(
        memoColorPicker
        
    )
}

export default ColorPicker